import { auth } from "@lumberset/api-client";
import { Logo } from "@lumberset/ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/** Frame for signing in: one quiet card in the middle of the screen. */
export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    // A set-password link works whoever is signed in here; that page sorts it out.
    if (location.pathname === "/set-password") return;
    const { data } = await auth.getSession();
    if (data) throw redirect({ to: "/" });
  },
  component: () => (
    <div className="pt-safe pb-safe flex min-h-dvh flex-col items-center justify-center bg-ui-bg-subtle px-4 py-10">
      <Logo className="mb-8 text-[17px]" markClassName="size-7" />
      <div className="w-full max-w-[400px] rounded-xl bg-ui-bg-base p-6 shadow-elevation-card-rest sm:p-8">
        <Outlet />
      </div>
      <p className="txt-compact-xsmall mt-8 text-ui-fg-muted">
        Admin panel: Billing Plans, Yards, Staff and platform settings.
      </p>
    </div>
  ),
});
